export class FindProjectsForm {
  selectedGrades: string[];
  
  constructor() {
    this.selectedGrades = [];
  }
}
